import React, { useState, useEffect, useRef } from 'react';
import Typography from '@mui/material/Typography';
import Stack from "@mui/material/Stack";
import {
  Grid,
  CardContent
} from "@mui/material";
import "./Dashboard.css";

export default function DashboardTopContainerCard({ day, cardclick, count, type, isActive }) {
  return (
    <>
      <Grid item xs={12} sm={6} md={4} lg={3}>
        <li className={isActive   ? ' cardstyle1' : 'cardstyle'}  onClick={() => cardclick(type)}>
          <CardContent>
            <Typography variant={"h6"} >
              {day}
            </Typography>
            <Stack direction="row" spacing={2}>
              <Typography variant={"h6"} >
                {count}
              </Typography>
            </Stack>
          </CardContent>
        </li>
      </Grid>

    </>
  )
}